<template>
  <div>
    <serviceList
      :pageTitle="$t('internationTruckPage.featureTitle')"
      :titleDesc="$t('internationTruckPage.featureText')"
      :bannerUrl="bannerUrl"
      :characterList="characterList"
      :imgTextList="imgTextList"
      isRightPostion
    />
  </div>
</template>

<script setup>
import serviceList from '../../components/template/serviceList.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const bannerUrl = require('@assets/images/banner/banner-international-truck.png');
const characterList = [
  {
    img: require('@assets/icons/ico-feature_1.svg'),
    title: t('internationTruckPage.feature1.title'),
    text: t('internationTruckPage.feature1.text'),
  },
  {
    img: require('@assets/icons/ico-feature_2.svg'),
    title: t('internationTruckPage.feature2.title'),
    text: t('internationTruckPage.feature2.text'),
  },
  {
    img: require('@assets/icons/ico-feature_3.svg'),
    title: t('internationTruckPage.feature3.title'),
    text: t('internationTruckPage.feature3.text'),
  },
]
const imgTextList = [
  {
    img: require('@assets/images/interational_truck_img_1.png'),
    title: t('internationTruckPage.description1.title'),
    text: t('internationTruckPage.description1.text'),
  },
  {
    img: require('@assets/images/interational_truck_img_2.png'),
    title: t('internationTruckPage.description2.title'),
    text: t('internationTruckPage.description2.text'),
  },
]
</script>